import config, {
    filtersUnrelatedToColumns,
} from 'app/PoC/DataGridDemoPages/EngagementsDemo/EngagementsDemo.config'
import SkyNetMasterDataGrid from '../components/SkyNetMasterDataGrid'

const EngagementsDemoPage = () => {
    return (
        <SkyNetMasterDataGrid
            config={config}
            filtersUnrelatedToColumns={filtersUnrelatedToColumns}
        />
    )
}

export default EngagementsDemoPage
